import { parse, print } from 'graphql';
export function resolveRequestDocument(document) {
    if (typeof document === `string`) {
        let operationName;
        try {
            const parsedDocument = parse(document);
            operationName = extractOperationName(parsedDocument);
        }
        catch (err) {
            // Failed parsing the document, the operationName will be undefined
        }
        return { query: document, operationName };
    }
    const operationName = extractOperationName(document);
    return { query: print(document), operationName };
}
function extractOperationName(document) {
    var _a, _b;
    let operationName;
    const operationDefinitions = document.definitions.filter((definition) => definition.kind === `OperationDefinition`);
    if (operationDefinitions.length === 1) {
        operationName = (_b = (_a = operationDefinitions[0]) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.value;
    }
    return operationName;
}
//# sourceMappingURL=document-utils.js.map